import type { BadgeProps } from 'components/HubertUI/HubertBadge';
import { HubertBadge } from 'components/HubertUI/HubertBadge';
import HubertTooltip from 'components/HubertUI/HubertTooltip';
import type { ComponentProps } from 'react';
import type { TInterviewRelations } from 'types/interview.types';
import type { TInterviewScoreTableDetail } from 'types/scores.types';
import { EIsAITags } from 'types/scores.types';

interface Props extends ComponentProps<typeof HubertBadge> {
  aiDetection: TInterviewRelations['aiDetectionSummary'] | TInterviewScoreTableDetail['aiDetection'];
}

const IsAI = ({ aiDetection }: Props) => {
  if (!aiDetection) {
    return null;
  }
  const customContainer = document.getElementById('main-content') as HTMLElement;

  if (!aiDetection.tag || !aiDetection.tag.length) {
    return (
      <HubertTooltip>
        <HubertTooltip.Trigger>
          <HubertBadge variant={'danger'} className="text-xs">
            Error
          </HubertBadge>
        </HubertTooltip.Trigger>
        <HubertTooltip.Content portalContent={true} portalElement={customContainer} side="bottom">
          <div>No AI Detection tag available.</div>
        </HubertTooltip.Content>
      </HubertTooltip>
    );
  }

  const text = aiDetection.tag.split('_').join(' ');
  let variant: BadgeProps['variant'];
  if ([EIsAITags.ExtremelyLikely, EIsAITags.Likely].includes(aiDetection.tag)) {
    variant = 'danger';
  } else if (EIsAITags.Possibly === aiDetection.tag) {
    variant = 'warning';
  } else if ([EIsAITags.Unlikely, EIsAITags.ExtremelyUnLikely].includes(aiDetection.tag)) {
    variant = 'success';
  } else {
    return null;
  }

  return (
    <HubertTooltip>
      <HubertTooltip.Trigger>
        <HubertBadge variant={variant} className="text-xs">
          {text}
        </HubertBadge>
      </HubertTooltip.Trigger>
      <HubertTooltip.Content portalContent={true} portalElement={customContainer} side="bottom">
        <div>Score: {aiDetection.score.toFixed(2)}</div>
      </HubertTooltip.Content>
    </HubertTooltip>
  );
};

export default IsAI;
